<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th(width="3%")
          span #
        th(width="17%")
          span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
        th.text-right(width="12%")
          .d-flex.justify-content-between
            span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
        th.text-right(width="12%")
          .d-flex.justify-content-between
            span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
        th.text-right(width="12%")
          .d-flex.justify-content-between
            span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
        th.text-right(width="12%")
          .d-flex.justify-content-between
            span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
        th.text-right(width="12%")
          .d-flex.justify-content-between
            span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
        th.text-right(width="9%")
          span(:title="$t('ui.game_type')") {{ $t("ui.game_type") }}
        th.text-right(width="11%")
          span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
        //- th.text-right(width="11%")
        //-   span(:title="$t('ui.table_id')") {{ $t("ui.table_id") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="9").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="item.result_id") {{ item.result_id }}
        td.text-right
          span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
        td.text-right
          span(:title="item.game_type") {{ item.game_type }}&nbsp;
        td.text-right
          span(:title="item.game_name") {{ item.game_name }}&nbsp;
        //- td.text-right
        //-   span(:title="item.table_id") {{ item.table_id }}&nbsp;
      tr.footer
        td.text-right(colspan="3")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayout)" :title="$n(subTotalPayout, 'currency')") {{ $n(subTotalPayout, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}

      tr.footer
        td.text-right(colspan="3")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayout)" :title="$n(grandTotalPayout, 'currency')") {{ $n(grandTotalPayout, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalPayout: 0,
    grandTotalPayout: 0
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalPayout = 0
      this.grandTotalPayout = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
          this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
          this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
          this.subTotalPayout = parseFloat(this.subTotalPayout) + parseFloat(value["payout"]);

        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalTurnover = totalTbl[0]["turnover"];
          this.grandTotalValidTurnover = totalTbl[0]["valid_turnover"];
          this.grandTotalWinLose = totalTbl[0]["winlose"];
          this.grandTotalPayout = totalTbl[0]["payout"];
        }
      }
    }
  }
};
</script>
